import { useMutation } from '@tanstack/react-query';
import { GET, GET_BARCODE } from '../../../../services';
import { openAlert } from '../../../../components/alert/hooks';

export const useGetBarcode = ({ getValues, reset }) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async (barcode) => {
      const response = await GET(GET_BARCODE(barcode));
      return response.result;
    },
    onSuccess: (result) => {
      openAlert({ model: 'message', type: 'success', message: 'ค้นหารหัสบาร์โค้ดสำเร็จ' });
      reset({
        ...getValues(),
        productName: result?.item?.productNameTh,
        productTypeName: result?.item?.productTypeName,
        productId: result?.item?.productId,
      });
    },
    onError: () => {
      reset({
        ...getValues(),
        productName: '',
        productTypeName: '',
        productId: '',
      });
    },
  });
  return { mutate, loading: isPending };
};
